import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import { makeStyles } from "@material-ui/core/styles";
import SuccesspopBlock from "./SuccessPopBlock";

const useStyles = makeStyles((theme) => ({
  Deleteicon: {
    color: "grey",
    "&:hover, &.Mui-focusVisible": { color: "#FF0027" },
  },
  rootBlock: {
    width: "23rem",
    height: "16rem",
  },

  topScrollPaper: {
    margin: "35px",
    alignItems: "flex-start",
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
  deletePopupNobutton: {
    width: "8rem",
    marginLeft: "5px",
    height: "1.75rem",
    backgroundColor: "#EEEEEE",
    borderRadius: "3px",
    opacity: 1,
    color: "#1f1f1f",
  },
  warningButton: {
    paddingTop: "20px !important",
    // color: "var(--unnamed-color-1f1f1f) ,
    font: "normal normal bold 16px/22px Open Sans !important",
    color: "#1F1F1F !important",
    opacity: 1,
  },
  deletePopupSuccessbutton: {
    width: "8rem",
    marginRight: "5px",
    height: "1.75rem",
    backgroundColor: "#001441",
    color: "white",
    borderRadius: "3px",
    opacity: 1,
    "&:hover, &.Mui-focusVisible": { backgroundColor: "#001441" },
  },
}));

const BlockDialogPopup = (props) => {
  const classes = useStyles();
  // const [open, setOpen] = React.useState(false);
  // const theme = useTheme();

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
    <div className="popup-box popup-shadow">
      <div className="box w-26rem">
        {/* <span className="close-icon" onClick={props.handlePopUpClose}>
          x
        </span> */}
        {/* {props.content} */}
        <div className={classes.rootBlock}>
          <DialogTitle id="responsive-dialog-title" align="center">
            <div className={classes.warningButton}>{"Warning!"}</div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText align="center">
              <img align="center" src="/images/warningicon.svg" />
            </DialogContentText>
          </DialogContent>
          <DialogContent>
            <DialogContentText>
              <p className="delete-report-popup">
                {" "}
                Are you sure to remove the reported content?{" "}
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ justifyContent: "center" }}>
            <Button
              onClick={() => {
                props.block();
                props.closeBlock();
               
              }}
              color="primary"
              className={classes.deletePopupSuccessbutton}
            >
              Yes
            </Button>

            <Button
              onClick={props.handleBlockPopUpClose}
              // className="bg-eee"
              className={classes.deletePopupNobutton}
              autoFocus
            >
              No
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
};

export default BlockDialogPopup;
